import { format } from 'date-fns/format'
import * as z from 'zod'

import * as constants from '@nxt-insurance/constants'

const Schema_Quote = z.object({
  premium_interval: z.enum(['P1M', 'P1Y']),
  startDate: z
    .preprocess((value) => {
      if (typeof value === 'string' || value instanceof Date) {
        return new Date(value)
      }
    }, z.date().optional())
    .transform((value) => {
      if (value === undefined) {
        return undefined
      }
      return format(value, constants.SERVER_DATE_FORMAT)
    }),
})

export default Schema_Quote
